import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BaseComponent from 'apps/new-web/views/component';
import NavItem from '../nav-item';
import Menu from '../menu';
import MenuColumn from '../menu-column';
import MenuItem from '../menu-item';
import Image from '../../../image';
import Hoverable from '../../../hoverable';
import { Grid, Row, Col } from 'apps/new-web/views/components/grid';
import I18n from 'apps/new-web/views/components/i18n';
import languageLib from '../../../../../lib/language';
import { actionCreators } from '../actions';

export class PurePostLoginDesktopHeader extends BaseComponent {
  static get propTypes() {
    return {
      user: PropTypes.object.isRequired,
      visibleMenu: PropTypes.string,
      languages: PropTypes.array.isRequired,
      lang: PropTypes.string.isRequired,
      assumedUserId: PropTypes.bool
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      createMenuVisible: false,
      logMenuVisible: false,
      supportMenuVisible: false,
      trainerMenuVisible: false,
      shopMenuVisible: false,
      settingsMenuVisible: false,
      languages: [],
      lang: ''
    };
  }

  showMenu(menuKey) {
    this.setState({ [menuKey]: true });
  }

  hideMenu(menuKey) {
    this.setState({ [menuKey]: false });
  }

  changeLanguage(value) {
    this.props.updateUserField('personal.locale', value);
    languageLib.handleLanguageChange(value);
  }

  componentDidMount() {
    const currentUrl = window.location.href;
    const isTestOrDevPage = currentUrl.includes('ifit-test') || currentUrl.includes('ifit-dev');
    this.setState({ isTestOrDevPage });
  }

  render() {
    const {
      shopMenuVisible,
      settingsMenuVisible
    } = this.state;

    const { isTestOrDevPage } = this.state;

    return (
      <Grid className="post-login-desktop-header centered-container hide-on-mobile hide-on-tablet">
        {this.props.assumedUserId &&
          <Row>
            <Col xs={ 12 } className="assumed-user-header">
              <div className="main-label">
                <h3>Assuming user:</h3>
                <span className="user-name">"{this.props.user.fullname}"</span>
              </div>
              <a href="/user/stop-assuming">Return to admin</a>
            </Col>
          </Row>
        }
        <Row>
          <Col lg={ 2 } md={ 2 } sm={ 2 } xs={ 12 } className="logo-container">
            <a href="/">
              <Image
                src="img/ifit-logo-dark-mc.svg"
                className="logo"
                alt="iFIT"
              />
            </a>
          </Col>
          <Col lg={ 7 } md={ 7 } sm={ 7 } xs={ 12 } className="post-menu">
            <ul className="menu-list">
              { isTestOrDevPage
                ? <NavItem
                  href="https://iconfitness--sbx.sandbox.my.site.com/MC/login"
                  label="Support Sandbox"
                />
                : <NavItem
                  href="https://my.ifit.com/MC/login"
                  label={ I18n.translate(
                    'Support',
                    'Label identifying help information.'
                  ) }
                />
              }
              <Hoverable
                menuKey="shopMenuVisible"
                onHoverStart={ this.showMenu }
                onHoverEnd={ this.hideMenu }
              >
                <NavItem
                  label={ I18n.translate(
                    'Shop',
                    'Label identifying the store to by iFIT products.'
                  ) }
                >
                  {shopMenuVisible && (
                    <Menu>
                      <MenuColumn>
                        <MenuItem
                          href="/renewal"
                          icon="deals.svg"
                          label={ I18n.translate('Membership') }
                        />
                        <MenuItem
                          href="https://shop.ifit.com/"
                          target="_blank"
                          label={ I18n.translate(
                            '[ifit] Shop',
                            { ifit: 'iFIT' },
                            'Label identifying the store to by iFIT products.'
                          ) }
                        />
                        <MenuItem
                          href="/treadmills"
                          label={ I18n.translate('Treadmills') }
                        />
                        <MenuItem
                          href="/bikes"
                          label={ I18n.translate('Bikes') }
                        />
                        <MenuItem
                          href="/ellipticals"
                          label={ I18n.translate('Ellipticals') }
                        />
                        <MenuItem
                          href="/rowers"
                          label={ I18n.translate('Rowers') }
                        />
                        <MenuItem
                          href="/cable-equipment"
                          label={ I18n.translate('Cable Equipment') }
                        />
                        <MenuItem
                          href="/fitness-mirrors"
                          label={ I18n.translate('Fitness Mirrors') }
                        />
                        <MenuItem href="/app" label={ I18n.translate('App') } />
                      </MenuColumn>
                    </Menu>
                  )}
                </NavItem>
              </Hoverable>
              <NavItem
                href="https://www.ifit.com/blog/"
                label={ I18n.translate(
                  'Blog',
                  'Label identifying the store to by iFIT products.'
                ) }
              />
            </ul>
          </Col>
          <Col lg={ 2 } md={ 2 } sm={ 2 } xs={ 11 } className="post-login-menu">
            <Hoverable
              menuKey="settingsMenuVisible"
              onHoverStart={ this.showMenu }
              onHoverEnd={ this.hideMenu }
            >
              <NavItem label={ this.props.user.fullname || '' }>
                {settingsMenuVisible && (
                  <Menu>
                    <MenuColumn>
                      <MenuItem
                        icon="settings.svg"
                        href="/settings"
                        label={ I18n.translate(
                          'Settings',
                          'Label identifying user preferences.'
                        ) }
                      />
                      <MenuItem
                        icon="logout.svg"
                        href="/logout"
                        label={ I18n.translate(
                          'Log out',
                          'Label signing out user from the iFIT account.'
                        ) }
                      />
                    </MenuColumn>
                  </Menu>
                )}
              </NavItem>
            </Hoverable>
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default connect(
  state => ({
    ...state.postLoginNavigation,
    lang: state.lang,
    languages: state.languages
  }),
  {
    updateUserField: actionCreators.updateUserField
  }
)(PurePostLoginDesktopHeader);
